import UsableLabel from "./UsableLabel";
export default UsableLabel;
